import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

export function RewardsHeader() {
  const t = useTranslations("rewards");
  return (
    <div className={stack({ gap: "8" })}>
      <h1 className={css({ textStyle: "subheading.md", color: "text.primary" })}>{t("title")}</h1>
      <p className={css({ textStyle: "body.lg", color: "text.tertiary" })}>{t("subtitle")}</p>
    </div>
  );
}
